// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"121":"gallery","177":"home","301":"test-erc4626","401":"appworks","714":"nft"}[chunkId] || chunkId) + "." + {"121":"4cae81f7","162":"ea9cb9ec","177":"0fc4e781","212":"9aee1bc6","301":"6959a84c","353":"3e6eb1fe","401":"53d8a734","415":"7fd499a2","714":"83634916"}[chunkId] + ".chunk.js";
};